import { createFileRoute } from "@tanstack/react-router";
import { Funds } from "@/components/Funds";

export const Route = createFileRoute("/_authenticated/funds/")({
  component: Funds,
  staticData: { page: "deals" },
});
